module.exports = __webpack_public_path__ + "static/interview_sowa-bf13ac65cc5b23f7f7b489932e3ea851.jpg";